import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstanceV2 from '../../Apis/AxiosV2';
import {
    PAYROLL_DEDUCTION_POLICY_SERVICE
} from '../EndPoints';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

export const GetAllDeductionPolicies = createAsyncThunk(
    'deductionPolicyService/getAll',
    async () => {
        const result = await apiInstanceV2
            .get(PAYROLL_DEDUCTION_POLICY_SERVICE.getAll)
            .then(r => r)
            .catch(e => e.response);
        return { data: result.data, status: result.status };
    },
);

export const CreateDeductionPolicy = createAsyncThunk(
    'deductionPolicyService/create',
    async (body) => {
        const result = await apiInstanceV2
            .post(PAYROLL_DEDUCTION_POLICY_SERVICE.create, body)
            .then(r => r)
            .catch(e => e.response);
        return { data: result.data, status: result.status };
    },
);

export const UpdateDeductionPolicy = createAsyncThunk(
    'deductionPolicyService/update',
    async (body) => {
        const result = await apiInstanceV2
            .put(PAYROLL_DEDUCTION_POLICY_SERVICE.update, body)
            .then(r => r)
            .catch(e => e.response);
        return { data: result.data, status: result.status };
    },
);

export const GetUserDeductionPolicy = createAsyncThunk(
    'deductionPolicyService/getUserDeductionPolicy',
    async (userId) => {
        const result = await apiInstanceV2
            .get(`${PAYROLL_DEDUCTION_POLICY_SERVICE.getUserDeductionPolicy}${userId}`)
            .then(r => r)
            .catch(e => e.response);
        return { data: result.data, status: result.status };
    },
);

export const UpdateUserDeductionPolicy = createAsyncThunk(
    'deductionPolicyService/updateUserDeductionPolicy',
    async (body) => {
        const result = await apiInstanceV2
            .put(PAYROLL_DEDUCTION_POLICY_SERVICE.updateUserDeductionPolicy, body)
            .then(r => r)
            .catch(e => e.response);
        return { data: result.data, status: result.status };
    },
);

export const CreateUserDeductionPolicy = createAsyncThunk(
    'deductionPolicyService/createUserDeductionPolicy',
    async (body) => {
        const result = await apiInstanceV2
            .post(PAYROLL_DEDUCTION_POLICY_SERVICE.createUserDeductionPolicy, body)
            .then(r => r)
            .catch(e => e.response);
        return { data: result.data, status: result.status };
    },
);
